import { render, staticRenderFns } from "./0.vue?vue&type=template&id=2c1fb763&scoped=true&"
var script = {}
import style0 from "./0.vue?vue&type=style&index=0&id=2c1fb763&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1fb763",
  null
  
)

export default component.exports